import { writable } from 'svelte/store';
export const isHaveItems = writable(false);
